<template>
    <div class="p-3 position-relative h-100" style="overflow-y: scroll">
        <div id="printMe">
            <div class="row">
                <div class="col">
                    <legend>Остаток отправки - {{date}}</legend>
                </div>
                <div class="col text-right d-print-none">
                    <button class="btn btn-outline-success" @click.prevent="$htmlToPaper('printMe')">Печать</button>
                </div>
            </div>
            <table class="table table-sm">
                <tbody>
                <tr v-for="order in leftOrders">
                    <td>{{order.TourName}}</td>
                    <td>{{order.Reception}}</td>
                    <td>
                        <router-link class="text-decoration-none text-dark"
                                     target="_blank"
                                     :to="{ name: 'order-info', params: {orderId: order.Id}}">
                            {{order.SferaNumber}}
                        </router-link>
                    </td>
                    <td>{{order.Amount}}</td>
                    <td>{{order.Name}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { get } from '@/admin/services/api/http-utils';

export default {
  props: {
    date: String,
  },
  data() {
    return {
      leftOrders: [],
    };
  },
  created() {
    this.fetchLeftOrders();
  },
  methods: {
    async fetchLeftOrders() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/dispatch/get-left-orders/${this.date}`);
      this.leftOrders = data;
    },
  },
};
</script>
